export default "__VITE_ASSET__CY6Vt57S__"